module.exports = __webpack_public_path__ + "static/media/delete.a786ba62.svg";